import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-newsletter-card',
  standalone: true,
  imports: [CommonModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <section class="news" aria-labelledby="news-title">
      <h3 id="news-title" class="news__title">Stay updated</h3>
      <p class="news__sub">Weekly UPSC mindmaps in your inbox.</p>
      <form class="news__form" (submit)="onSubmit($event)">
        <label class="visually-hidden" for="news-email">Email address</label>
        <input id="news-email"
               class="news__input"
               type="email"
               required
               placeholder="you@example.com"
               [(ngModel)]="email"
               name="email"
               autocomplete="email">
        <button type="submit" class="news__btn" [disabled]="!email">Subscribe</button>
      </form>
    </section>
  `,
  styles: [`
    .news {
      padding: var(--space-5);
      border-radius: var(--radius-lg);
      background: linear-gradient(135deg, var(--color-primary-50) 0%, var(--color-surface) 100%);
      border: 1px solid var(--color-border);
      box-shadow: var(--shadow-sm);
    }
    .news__title { font-size: var(--fs-lg); margin-bottom: var(--space-1); color: var(--color-text-primary); }
    .news__sub   { font-size: var(--fs-sm); color: var(--color-text-secondary); margin-bottom: var(--space-4); }
    .news__form  { display: flex; flex-direction: column; gap: var(--space-2); }
    .news__input {
      padding: var(--space-3) var(--space-4);
      border-radius: var(--radius-md);
      border: 1px solid var(--color-border);
      background: var(--color-surface);
      font-size: var(--fs-sm);
    }
    .news__input:focus { outline: 2px solid var(--color-primary-500); outline-offset: 1px; }
    .news__btn {
      padding: var(--space-3) var(--space-4);
      border-radius: var(--radius-md);
      border: 0;
      background: var(--color-accent-500);
      color: #fff;
      font-weight: var(--fw-semibold);
      cursor: pointer;
      transition: background var(--dur-fast) var(--ease-out);
    }
    .news__btn:hover:not([disabled]) { background: var(--color-accent-600); }
    .news__btn[disabled] { opacity: 0.5; cursor: not-allowed; }
    .visually-hidden {
      position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px;
      overflow: hidden; clip: rect(0,0,0,0); white-space: nowrap; border: 0;
    }
  `]
})
export class NewsletterCardComponent {
  @Output() subscribe = new EventEmitter<string>();
  email = '';

  onSubmit(evt: Event): void {
    evt.preventDefault();
    if (!this.email) return;
    this.subscribe.emit(this.email);
    this.email = '';
  }
}
